/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./AdjustmentDetails.module.css";

interface DetailRowProps {
  amount: string;
  iconSrc: string;
}

const DetailRow: React.FC<DetailRowProps> = ({ amount, iconSrc }) => {
  return (
    <div className={styles.detailRow}>
      <img loading="lazy" src={iconSrc} className={styles.detailIcon} alt="" />
      <span>{amount}</span>
    </div>
  );
};

export default DetailRow;
